import React, { useEffect, useRef, useState, useCallback } from "react";
import Avatar from 'react-avatar';
import { Contacts } from '@capacitor-community/contacts';
import SumsubWebSdk from '@sumsub/websdk-react';
import { AiOutlineBank } from "react-icons/ai";

import {
  IonContent,
  IonLabel,
  IonHeader,
  useIonAlert,
  IonIcon,
  IonItem,
  IonPage,
  IonCard,
  IonCardContent,
  IonCardSubtitle,
  IonCardHeader,
  IonNote,
  IonSearchbar,
  IonModal,
  IonThumbnail,
  IonItemSliding,
  IonItemOptions,
  IonItemOption,
  IonButton,
  IonButtons,
  IonToolbar,
  IonLoading,
  IonText,
  useIonModal,
  IonGrid,
  IonRow,
  IonCol,
  IonTitle,
  IonChip,
  IonCheckbox,
  useIonRouter,

} from "@ionic/react";
import { useTranslation } from "react-i18next";
import "./RecipientPage.css";
import { addOutline, arrowBackOutline, closeOutline, pencilOutline, repeatOutline, swapVerticalOutline, trash, trendingDownOutline, trendingUpOutline, businessOutline, walletOutline, peopleOutline, gridOutline } from "ionicons/icons";


import { PayStellarUri } from "../../services/stellar/stellar-uri/pay-stellar-uri";
import { shortenAccountId } from "../../services/stellar/stellar-utils";
import { ebioroApi, useContactsInPlatformMutation, useDeleteBeneficiaryMutation, useGetBeneficiariesQuery } from "../../services/api/ebioro/ebioro";
import { useAppSelector, useAppDispatch } from "../../services/redux/hook";
import { BeneficiaryRequestParams, BeneficiaryResponse, ContactsInPlatformResponse, DestinationUserName, PaymentDestinationInfo, UserInfo } from "../../types/types";
import { setPaymentDestinationInfo } from "../../services/redux/slices/paymentDestinationInfo/paymentDestinationInfo";
import { useHistory } from "react-router";
import { Capacitor } from "@capacitor/core";
import SumsubPlugin from "../../services/sumsubPlugin/sumsubPlugin";
import * as Sentry from '@sentry/react';
import { Keyboard } from "@capacitor/keyboard";
import PlatformRecipientPage from "./platform-recipient/PlatformRecipient";
import AmountPage from "../amount/AmountPage";
import ExternalRecipientPage from "./external-wallet/ExternalRecipient";
import { IconContext } from "react-icons";
import { Provider } from "react-redux";
import { store } from "../../services/redux/store";
import { closeModal } from "@/services/redux/slices";


const Page: React.FC = () => {

  const [presentAlert] = useIonAlert();
  const pageRef = useRef();
  const [goBack, setGoBack] = useState(false);


  const nav = document.querySelector("ion-nav");

  const close = () => {
    dispatch(closeModal());
  }

  useEffect(() => {
    const checkNavigation = async () => {
      // Add delay for nav stack initialization
      await new Promise(resolve => setTimeout(resolve, 150));
      
      const canGoBackResult = await nav?.canGoBack();
      
      if (canGoBackResult) {
        setGoBack(true);
      }
    };
    
    checkNavigation();
  }, []);

  const handleNavigation = async () => {
    const canGoBackResult = await nav?.canGoBack();
    
    if (canGoBackResult) {
      nav?.pop();
    } else {
      close();
    }
  }

  const presentAddressVerificationAlert = async () => {

    presentAlert({
      header: t('recipient.page.VERIFICATION-HEADER'),
      message: t('recipient.page.VERIFICATION-MESSAGE'),
      buttons: [
        {
          text: t('recipient.page.VERIFICATION-BTN-CANCEL'),
          role: 'cancel',
          handler: () => {
            //setHandlerMessage('Alert canceled');
          },
        },
        {
          text: t('recipient.page.VERIFICATION-BTN-CONFIRM'),
          role: 'confirm',
          handler: async () => {
            await startVerification(userInfo)
          },
        },
      ],
      // onDidDismiss: (e: CustomEvent) => console.log('the event '+JSON.stringify(e)),
    })
  }

  const dispatch = useAppDispatch();
  const { t, i18n } = useTranslation();
  const history = useHistory();
  const [showLoading, setShowLoading] = useState(false);
  const [searchValue, setSearchValue] = useState<string>('');
  const [payUri, setPayUri] = useState(new PayStellarUri());
  //const seletedTab = useAppSelector((state) => state.selectedTab);
  const paymentDestInfo = useAppSelector((state) => state.paymentDestinationInfo);
  const selectedAsset = useAppSelector((state) => state.selectedAsset);
  const asset = paymentDestInfo.destination_asset || selectedAsset;
  const userInfo: UserInfo = useAppSelector((state) => state.user);
  // Original lists from API
  const [contactsInPlatformOriginal, setContactsInPlatformOriginal] = useState<ContactsInPlatformResponse[]>([]);
  const [beneficiariesOriginal, setBeneficiariesOriginal] = useState<BeneficiaryResponse[]>([]);

  // Filtered lists for display (combines filter + search)
  const [contactsInPlatformList, setContactsInPlatform] = useState<ContactsInPlatformResponse[]>([]);
  const [beneficiariesList, setBeneficiariesList] = useState<BeneficiaryResponse[]>([]);
  const registrationLevel = import.meta.env.VITE_KYC_REGISTRATION_LEVEL_FULL;
  const [kycToken, setKycToken] = useState('');
  const [kycTestEnvironment, setKycTestEnvironment] = useState(false);
  const [verificationConfig, setVerificationConfig] = useState({});
  const [showVerificationScreen, setShowVerificationScreen] = useState(false);
  const verificationScreenModal = useRef<HTMLIonModalElement>(null);
  const [contactsInPlatform, contactsInPlatformResult] = useContactsInPlatformMutation();
  const [deleteBeneficiary, deleteBeneficiaryResult] = useDeleteBeneficiaryMutation();

  // Filter states
  type RecipientFilter = 'all' | 'friends' | 'ebioro' | 'external' | 'bank';
  const [activeFilter, setActiveFilter] = useState<RecipientFilter>('all');


  const RecipientModal: React.FC<any> = () => {

    return (

      <>
        <IonContent className="ion-padding">
          <IonCard>
            <IonCardContent>
              <IonGrid>
                <IonRow>
                  {/* Bank Payment Option */}
                  <IonCol size="4">
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        padding: '15px',
                        borderRadius: '12px',
                        backgroundColor: '#f5f5f5',
                        cursor: 'not-allowed',
                        minHeight: '100px',
                        justifyContent: 'center',
                        opacity: 0.5,
                        pointerEvents: 'none'
                      }}
                    >

                      <IonText slot='start' color="medium">
                        <IconContext.Provider value={{ size: "28px" }} >

                          <AiOutlineBank />

                        </IconContext.Provider>
                      </IonText>
                      <IonText style={{ textAlign: 'center', color: '#999' }}>
                        <h6 style={{ margin: '0', fontWeight: 'bold' }}>
                          {t('recipient.page.RECIPIENT-MODAL-BANK-LABEL') || 'Bank'}
                        </h6>
                      </IonText>
                    </div>
                  </IonCol>

                  {/* Ebioro User Option */}
                  <IonCol size="4">
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        padding: '15px',
                        borderRadius: '12px',
                        backgroundColor: '#f5f5f5',
                        cursor: 'pointer',
                        minHeight: '100px',
                        justifyContent: 'center'
                      }}
                      onClick={() => {
                        dismissAddRecipientModal();
                        nav?.push(() => <PlatformRecipientPage />)
                      }}
                    >
                      <img
                        src="/assets/img/ebioro-symbol-black.svg"
                        alt="Ebioro"
                        style={{
                          width: '28px',
                          height: '28px',
                          marginBottom: '8px'
                        }}
                      />
                      <IonText style={{ textAlign: 'center', color: '#333' }}>
                        <h6 style={{ margin: '0', fontWeight: 'bold' }}>
                          {t('recipient.page.RECIPIENT-MODAL-EBIORO-USER-LABEL') || 'Ebioro User'}
                        </h6>
                      </IonText>
                    </div>
                  </IonCol>

                  {/* External Wallet Option */}
                  <IonCol size="4">
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        padding: '15px',
                        borderRadius: '12px',
                        backgroundColor: '#f5f5f5',
                        cursor: 'pointer',
                        minHeight: '100px',
                        justifyContent: 'center'
                      }}
                      onClick={() => { addExternalWalletRecipient() }}
                    >
                      <IonIcon
                        icon={walletOutline}
                        style={{
                          fontSize: '28px',
                          color: '#3880ff',
                          marginBottom: '8px'
                        }}
                      />
                      <IonText style={{ textAlign: 'center', color: '#333' }}>
                        <h6 style={{ margin: '0', fontWeight: 'bold' }}>
                          {t('recipient.page.RECIPIENT-MODAL-EXTERNAL-LABEL') || 'External Wallet'}
                        </h6>
                      </IonText>
                    </div>
                  </IonCol>
                </IonRow>
              </IonGrid>
            </IonCardContent>
          </IonCard>
        </IonContent>
      </>

    )
  }

  const [showAddRecipientModal, dismissAddRecipientModal] = useIonModal(<RecipientModal />);

  const [present] = useIonAlert();
  const presentErrorAlert = (message: any) => {
    present({
      header: "Error",
      message: `${message}`,
      buttons: [
        {
          text: "Close",
          role: "cancel",
          handler: () => {
            return;
          },
        },
      ],
    });
  };

  const [presentDeleteAlert] = useIonAlert();

  const handleBankRecipient = async () => {

    if (userInfo.kyc_status_fiat === "NEEDS_INFO") {

      const token = await getKYCToken();
    }

  }

  const addExternalWalletRecipient = () => {
    dismissAddRecipientModal();
    nav?.push(() => <ExternalRecipientPage />)

  }

  const goToUpdateRecipient = async (beneficiary: BeneficiaryResponse) => {

    await document.querySelector("ion-item-sliding")?.closeOpened();

    if (beneficiary.account_type === 'bank') {

    }

    if (beneficiary.account_type === 'payment_identifier') {

      nav?.push(() => <PlatformRecipientPage beneficiary={beneficiary} />)

    }

    if (beneficiary.account_type === 'stellar_wallet') {

      nav?.push(() => <ExternalRecipientPage beneficiary={beneficiary} />)

    }
  }

  const confirmDeleteRecipient = (beneficiary: BeneficiaryResponse) => {

    presentDeleteAlert({
      header: t('recipient.page.RECIPIENT-DELETE-CONFIRM-ALERT-MESSAGE'),
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          handler: () => {
            { };
          },
        },
        {
          text: 'OK',
          role: 'confirm',
          handler: async () => {
            await deleteRecipient(beneficiary);
          },
        },
      ],
    })

  }

  const deleteRecipient = async (beneficiary: BeneficiaryResponse) => {

    const deleteParams: BeneficiaryRequestParams = {

      id: beneficiary.id,
      user_id: userInfo.id

    }

    try {

      await document.querySelector("ion-item-sliding")?.closeOpened();

      await deleteBeneficiary(deleteParams).unwrap();

      setTimeout(async () => {

        await displayBeneficiaries();
      }, 500) // somehow need to add this here because calling display beneficiary direcltly without the timeout does not work

    } catch (error) {

      presentErrorAlert(JSON.stringify(error))

    }



  }

  const goToNextPageUser = async (user: any) => {

    const userStellarAccount = user.stellar_account.public_key;

    let destination_username: DestinationUserName = {

      name: (user.first_name && user.last_name) ? `${user.first_name} ${user.last_name}` : undefined,
      username: (user.payment_link) ? user.payment_link : undefined

    }

    // Preserve existing paymentDestinationInfo and only update recipient-specific fields
    const destinationInfo: PaymentDestinationInfo = {
      ...paymentDestInfo,
      destination_address: userStellarAccount,
      destination_amount: payUri.amount || paymentDestInfo.destination_amount,
      destination_username: destination_username
    }

    dispatch(setPaymentDestinationInfo(destinationInfo));

    if (!payUri.amount) {

      nav?.push(() => <AmountPage />);
    }

  };

  const goToNextPagePlatformUser = async (beneficiary: BeneficiaryResponse) => {

    const userStellarAccount = beneficiary.stellar_account;

    let destination_username: DestinationUserName = {

      name: beneficiary.payment_id_name as string,
      username: beneficiary.payment_id as string

    }

    // Preserve existing paymentDestinationInfo and only update recipient-specific fields
    const destinationInfo: PaymentDestinationInfo = {
      ...paymentDestInfo,
      destination_address: userStellarAccount,
      destination_amount: undefined,
      destination_username: destination_username
    }

    dispatch(setPaymentDestinationInfo(destinationInfo));

    if (!payUri.amount) {

      nav?.push(() => <AmountPage />);

    }

  }

  const goToExternalWalletAmount = async (beneficiary: BeneficiaryResponse) => {
    // Preserve existing paymentDestinationInfo and only update recipient-specific fields
    const destinationInfo: PaymentDestinationInfo = {
      ...paymentDestInfo,
      destination_address: beneficiary.stellar_account!,
      destination_username: beneficiary.payment_id_name ? { name: beneficiary.payment_id_name } : undefined,
      destination_memo: beneficiary.memo || undefined,
      destination_memo_type: beneficiary.memo_type || 'text',
      destination_amount: undefined
    }

    dispatch(setPaymentDestinationInfo(destinationInfo));
    nav?.push(() => <AmountPage />);
  }

  // const goToBankTransferAmount = async (beneficiary: BeneficiaryResponse) => {

  //   const response = await dispatch(ebioroApi.endpoints.getUserInfo.initiate(undefined, { forceRefetch: true })).unwrap();

  //   const userKYCStatus = response.kyc_status_fiat;

  //   if (userKYCStatus === "NEEDS_INFO" || !response.proof_of_residence_id) {
  //     presentAddressVerificationAlert()
  //     return;
  //   }

  //   if (userKYCStatus === "PROCESSING" || userKYCStatus === "REJECTED") {

  //     await startVerification(response);
  //     return;

  //   }


  //   if (seletedTab === 'send') {

  //     history.push(
  //       {
  //         pathname: '/tabs/payments/bank_transfer/amount',
  //         state: { beneficiary }
  //       }

  //     )

  //   }

  //   else {

  //     history.push({
  //       pathname: '/tabs/accounts/bank_transfer/amount',
  //       state: { beneficiary }
  //     }

  //     )

  //   }

  // }  // New function to apply both filters and search
  const applyFiltersAndSearch = useCallback((beneficiaries: BeneficiaryResponse[], contacts: ContactsInPlatformResponse[]) => {
    let filteredBeneficiaries = [...beneficiaries];
    let filteredContacts = [...contacts];

    // Apply search filter if there's a search query
    if (searchValue.trim()) {
      const query = searchValue.toLowerCase();

      // Filter beneficiaries by name, payment_id, or phone number
      filteredBeneficiaries = beneficiaries.filter((beneficiary) => {
        const nameMatch =
          (beneficiary.payment_id_name && beneficiary.payment_id_name.toLowerCase().includes(query)) ||
          (beneficiary.first_name && beneficiary.first_name.toLowerCase().includes(query)) ||
          (beneficiary.last_name && beneficiary.last_name.toLowerCase().includes(query)) ||
          (beneficiary.second_last_name && beneficiary.second_last_name.toLowerCase().includes(query)) ||
          (beneficiary.payment_id && beneficiary.payment_id.toLowerCase().includes(query));

        // Phone number search (partial matching)
        const phoneMatch = beneficiary.phone_number && beneficiary.phone_number.includes(query);

        return nameMatch || phoneMatch;
      });

      // Filter contacts by name or phone number
      filteredContacts = contacts.filter((contact) => {
        const nameMatch =
          contact.first_name?.toLowerCase().includes(query) ||
          contact.last_name?.toLowerCase().includes(query);

        // Phone number search (partial matching)
        const phoneMatch = contact.mobile_number && contact.mobile_number.includes(query);

        return nameMatch || phoneMatch;
      });
    }

    // Apply recipient type filter for beneficiaries
    if (activeFilter !== 'all') {
      switch (activeFilter) {
        case 'friends':
          filteredBeneficiaries = []; // Don't show beneficiaries in friends filter
          break;
        case 'ebioro':
          filteredBeneficiaries = filteredBeneficiaries.filter(b => b.account_type === 'payment_identifier');
          filteredContacts = []; // Don't show contacts in ebioro filter
          break;
        case 'external':
          filteredBeneficiaries = filteredBeneficiaries.filter(b => b.account_type === 'stellar_wallet');
          filteredContacts = []; // Don't show contacts in external filter
          break;
        case 'bank':
          filteredBeneficiaries = filteredBeneficiaries.filter(b => b.account_type === 'bank');
          filteredContacts = []; // Don't show contacts in bank filter
          break;
      }
    }

    // For friends filter, only show contacts
    if (activeFilter === 'friends') {
      filteredBeneficiaries = [];
    }

    setBeneficiariesList(filteredBeneficiaries);
    setContactsInPlatform(filteredContacts);
  }, [searchValue, activeFilter]); // Dependencies: only searchValue and activeFilter

  const handleChange = (ev: Event) => {
    const target = ev.target as HTMLIonSearchbarElement;

    if (target) {
      // Only update searchValue after debounce - this triggers the filtering
      setSearchValue(target.value || '');
    }
  };

  const displayBeneficiaries = useCallback(async () => {

    try {

      const result = await dispatch(ebioroApi.endpoints.getBeneficiaries.initiate(userInfo.id, { forceRefetch: true })).unwrap();
      setBeneficiariesOriginal(result);
      applyFiltersAndSearch(result, contactsInPlatformOriginal);

    } catch (error) {
      console.error('Error loading beneficiaries:', error);
      // Optionally show an error alert to user
      // presentErrorAlert({ data: t('error.loading_beneficiaries') });
    }

  }, [dispatch, userInfo.id, contactsInPlatformOriginal, applyFiltersAndSearch]);

  const getContacts = useCallback(async () => {

    if (Capacitor.getPlatform() != 'web') {

      try {

        //setShowLoading(true);

        const phones = [];
        const projection = {
          // Specify which fields should be retrieved.
          name: true,
          phones: true
        };

        const result = await Contacts.getContacts({
          projection,
        });
        // setShowLoading(false);

        for (const contact of result.contacts) {

          if (contact.name?.display && contact.phones?.length) {

            for (const phone of contact.phones) {
              let temp = "+" + phone.number?.replace(/\D/g, '');
              phones.push(temp)
            }
          }
        }

        const response = await contactsInPlatform(phones).unwrap();

        setContactsInPlatformOriginal(response);
        applyFiltersAndSearch(beneficiariesOriginal, response);



      } catch (error) {

        // this error can happen if no permission has been given.

        setShowLoading(false);

      }

    }

  }, [contactsInPlatform, beneficiariesOriginal, applyFiltersAndSearch]);

  const startVerification = async (userInfo: UserInfo) => {

    const verifyConfig = {
      email: userInfo.email,
      phone: userInfo.mobile_number,
    }

    try {

      const response = await dispatch(ebioroApi.endpoints.getKYCToken.initiate(registrationLevel as string)).unwrap(); // we are putting here just XLM as the default asset to start the verification flow
      setKycToken(response.accessToken);
      setKycTestEnvironment(response.testEnvironment);
      setVerificationConfig(verifyConfig);

      if (response) {

        Capacitor.getPlatform() === 'web' ? openVerificationScreen() : openNativeVerificationScreen(response)
      }

    } catch (error) {

      Sentry.captureException(error)

      presentErrorAlert({ data: t('application.uncaught.ERROR') })
      return

    }

  }

  const openVerificationScreen = async () => {

    setShowVerificationScreen(true);
  }

  const openNativeVerificationScreen = async (kycTokenResponse: any) => {

    try {

      SumsubPlugin.launch({ accessToken: kycTokenResponse.accessToken })

    } catch (error) {

      Sentry.captureException(error)

    }


  }

  const getKYCToken = async () => {

    const { data: kycTokenResponse, error } = await dispatch(ebioroApi.endpoints.getKYCToken.initiate(registrationLevel as string));
    return kycTokenResponse.accessToken

  }

  const openRecipientModal = async () => {

    showAddRecipientModal({
      presentingElement: pageRef.current,
      initialBreakpoint: 0.30,
      breakpoints: [0, 0.30, 0.5, 0.75]
    })
  }

  useEffect(() => {

    const init = async () => {
      await getContacts();
    }

    init();

  }, [getContacts]);

  // Apply filters whenever search value or active filter changes
  useEffect(() => {
    applyFiltersAndSearch(beneficiariesOriginal, contactsInPlatformOriginal);
  }, [searchValue, activeFilter, beneficiariesOriginal, contactsInPlatformOriginal]);

  useEffect(() => {
    // Load beneficiaries on component mount
    displayBeneficiaries();
  }, [displayBeneficiaries]); // Only re-run if displayBeneficiaries changes

  const handleScrollStart = async () => {

    if (Capacitor.getPlatform() === 'ios' || Capacitor.getPlatform() === 'android') {
      Keyboard.hide();
    }

  }

  return (

    <IonPage>

      <IonHeader className="ion-no-border">

        <IonToolbar style={{ marginTop: "0%" }}>
          <IonButtons slot='start'>
            <IonButton onClick={handleNavigation} color='primary'>
              <IonIcon
                slot="icon-only"
                icon={goBack ? arrowBackOutline : closeOutline}
              />
            </IonButton>
          </IonButtons>
          <IonTitle>
            {t('recipient.page.WHO-TO-SEND-LABEL') as string}
          </IonTitle>

          <IonButtons slot="end">
            <IonButton color={'primary'} onClick={() => { openRecipientModal() }}>
              <IonIcon icon={addOutline} color="primary" />
            </IonButton>
          </IonButtons>

        </IonToolbar>


        <IonToolbar className="recipientToolBar">
          <IonSearchbar
            className="searchbar-input search-bar-global"
            onIonInput={(ev: any) => handleChange(ev)}
            placeholder={t('recipient.page.SEARCH-BAR-PLACEHOLDER') as string}
            debounce={1000}
          />
        </IonToolbar>

        {/* Filter Chips */}
        <IonToolbar style={{ paddingTop: '8px', paddingBottom: '8px' }}>
          <IonGrid>
            <IonRow className="ion-justify-content-start" style={{ gap: '8px', paddingLeft: '16px' }}>
              <IonChip
                color={activeFilter === 'all' ? 'primary' : 'white'}
                onClick={() => setActiveFilter('all')}
              >
                <IonIcon icon={gridOutline} />
                <IonLabel>{t('recipient.page.chip.ALL-LABEL')}</IonLabel>
              </IonChip>

              {contactsInPlatformOriginal.length > 0 && (
                <IonChip
                  color={activeFilter === 'friends' ? 'primary' : 'white'}
                  onClick={() => setActiveFilter('friends')}
                >
                  <IonIcon icon={peopleOutline} />
                  <IonLabel>{t('recipient.page.chip.FRIENDS-LABEL')}</IonLabel>
                </IonChip>
              )}

              {beneficiariesOriginal?.filter((b) => b.account_type === 'payment_identifier').length > 0 && (
                <IonChip
                  color={activeFilter === 'ebioro' ? 'primary' : 'white'}
                  onClick={() => setActiveFilter('ebioro')}
                >
                  <IonIcon icon={addOutline} />
                  <IonLabel>{t('recipient.page.chip.EBIORO-LABEL')}</IonLabel>
                </IonChip>
              )}

              {beneficiariesOriginal?.filter((b) => b.account_type === 'stellar_wallet').length > 0 && (
                <IonChip
                  color={activeFilter === 'external' ? 'primary' : 'white'}
                  onClick={() => setActiveFilter('external')}
                >
                  <IonIcon icon={walletOutline} />
                  <IonLabel>{t('recipient.page.chip.EXTERNAL-LABEL')}</IonLabel>
                </IonChip>
              )}
            </IonRow>
          </IonGrid>
        </IonToolbar>

      </IonHeader>

      <IonContent scrollEvents={true}
        onIonScrollStart={handleScrollStart} >

        <IonLoading isOpen={showLoading} />

        {/** Friends */}

        <IonCard hidden={!contactsInPlatformList.length || (activeFilter !== 'all' && activeFilter !== 'friends')}>

          <IonCardHeader>
            <IonCardSubtitle style={{ "textAlign": "left" }} >{t('recipient.page.CONTACTS-USERS-LIST-HEADER')}</IonCardSubtitle>
          </IonCardHeader>

          <IonCardContent>

            
              {
                contactsInPlatformList.map((contact, index) => {

                  return (

                    <IonItem lines="none" className="recipientsPageItemList" key={index} onClick={() => { goToNextPageUser(contact) }}>

                      <IonGrid>

                        <IonRow>
                          <IonCol size="2">
                            <Avatar name={`${contact.first_name} ${contact.last_name}`} size="45" round={true} email={contact.email} />
                          </IonCol>

                          <IonCol>

                            <IonItem lines="none">
                              <IonLabel className="ion-text-wrap">
                                <h4>
                                  {`${contact.first_name} ${contact.last_name}`}
                                </h4>
                                <IonNote className='accountsPage_IonNote'>
                                  {`${contact.mobile_number}`}
                                </IonNote>

                              </IonLabel>
                            </IonItem>

                          </IonCol>
                        </IonRow>

                      </IonGrid>

                    </IonItem>
                  )

                })
              }

          </IonCardContent>
        </IonCard>

        {/** External Wallet Beneficiaries */}
        <IonCard hidden={!beneficiariesList?.filter((b) => b.account_type === 'stellar_wallet' && b.stellar_account).length || (activeFilter !== 'all' && activeFilter !== 'external')}>
          <IonCardHeader>
            <IonCardSubtitle style={{ "textAlign": "left" }}>{t('recipient.page.SAVED-EXTERNAL-WALLETS')}</IonCardSubtitle>
          </IonCardHeader>
          <IonCardContent>
          
              {
                beneficiariesList?.map((beneficiary, index) => {
                  if (beneficiary.account_type === 'stellar_wallet' && beneficiary.stellar_account) {
                    return (
                      <IonItemSliding key={index}>
                        <IonItem lines="none" onClick={() => goToExternalWalletAmount(beneficiary)}>
                          <IonThumbnail slot="start">
                            <div style={{
                              width: '40px',
                              height: '40px',
                              borderRadius: '50%',
                              backgroundColor: '#3880ff',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center'
                            }}>
                              <IonIcon icon={walletOutline} style={{ color: 'white', fontSize: '20px' }} />
                            </div>
                          </IonThumbnail>
                          <IonLabel className="ion-text-wrap">
                            <h4>{beneficiary.payment_id_name}</h4>
                            <IonNote className='accountsPage_IonNote'>
                              {shortenAccountId(beneficiary.stellar_account, 16)}
                              {beneficiary.memo && <span> • Memo: {beneficiary.memo}</span>}
                            </IonNote>
                          </IonLabel>
                        </IonItem>
                        <IonItemOptions>
                          <IonItemOption color="primary" onClick={() => { goToUpdateRecipient(beneficiary) }}>
                            <IonIcon slot="icon-only" icon={pencilOutline} color="light"></IonIcon>
                          </IonItemOption>
                          <IonItemOption color="danger" onClick={() => { confirmDeleteRecipient(beneficiary) }}>
                            <IonIcon slot="icon-only" icon={trash} color="light"></IonIcon>
                          </IonItemOption>
                        </IonItemOptions>
                      </IonItemSliding>
                    )
                  }
                  return null;
                })
              }
        
          </IonCardContent>
        </IonCard>

        {/** Bank Beneficiaries */}
        {/* <IonCard hidden={(!beneficiariesList?.filter((b) => { return b.account_type === 'bank' }).length) || (!asset.remittances_enabled)}>
          <IonCardHeader>
            <IonCardSubtitle style={{ "textAlign": "left" }} >{t('recipient.page.BANKS-RECIPIENTS-LIST-HEADER')}</IonCardSubtitle>
          </IonCardHeader>
          <IonCardContent>

            {
              beneficiariesList?.map((beneficiary, index) => {

                if (beneficiary.account_type === 'bank') {

                  return (
                    <IonItem lines="none" key={index}>
                      <IonGrid>
                        <IonRow>
                          <IonCol>
                            <Avatar name={`${beneficiary.first_name} ${beneficiary.last_name} ${beneficiary.second_last_name}`} size="45" round={true} />
                          </IonCol>
                          <IonCol>
                          <IonItemSliding>
                        <IonItem lines="none" onClick={() => { goToBankTransferAmount(beneficiary) }}>
                          <IonLabel className="ion-text-wrap">
                            <h4>
                              {`${beneficiary.first_name} ${beneficiary.last_name} ${beneficiary.second_last_name}`}
                            </h4>
                            <IonNote>
                              <h5>{beneficiary.bank_name}</h5>

                              <IonLabel>
                                {shortenAccountId(`${beneficiary.account_number}`, 16)}

                              </IonLabel>
                            </IonNote>

                          </IonLabel>
                        </IonItem>
                        <IonItemOptions>
                          <IonItemOption color="primary"
                            onClick={() => { goToUpdateRecipient(beneficiary) }}>
                            <IonIcon slot="icon-only" icon={pencilOutline} color="light"></IonIcon>
                          </IonItemOption>
                          <IonItemOption color="danger"
                            onClick={() => { confirmDeleteRecipient(beneficiary) }}>
                            <IonIcon slot="icon-only" icon={trash} color="light"></IonIcon>
                          </IonItemOption>
                        </IonItemOptions>
                      </IonItemSliding>
                          </IonCol>
                        </IonRow>
                      </IonGrid>
                      
                 
                    </IonItem>
                  )
                }

              })
            }

          </IonCardContent>
        </IonCard> */}

        {/** Platform Beneficiaries (Ebioro Users) */}
        <IonCard hidden={!beneficiariesList?.filter((b) => b.account_type === 'payment_identifier').length || (activeFilter !== 'all' && activeFilter !== 'ebioro')}>
          <IonCardHeader>
            <IonCardSubtitle style={{ "textAlign": "left" }} >{t('recipient.page.PLATFORMS-RECIPIENTS-LIST-HEADER')}</IonCardSubtitle>
          </IonCardHeader>
          <IonCardContent>

              {
                beneficiariesList?.map((beneficiary, index) => {

                  if (beneficiary.account_type === 'payment_identifier') {

                    return (
                      <IonItemSliding key={index}>
                        <IonItem lines="none" onClick={() => { goToNextPagePlatformUser(beneficiary) }}>
                          <IonGrid>
                            <IonRow>
                              <IonCol size="2">
                                <Avatar name={`${beneficiary.payment_id_name}`} size="45" round={true} />
                              </IonCol>

                              <IonCol>
                                <IonItem lines="none">
                                <IonLabel className="ion-text-wrap">
                                  <h4>
                                    {`${beneficiary.payment_id_name}`}
                                  </h4>
                                  <IonNote>
                                    <h5>{beneficiary.payment_id}</h5>
                                  </IonNote>
                                </IonLabel>
                              </IonItem>
                              </IonCol>
                            </IonRow>
                          </IonGrid>
                        </IonItem>
                        <IonItemOptions>
                          <IonItemOption color="primary" onClick={() => { goToUpdateRecipient(beneficiary) }}>
                            <IonIcon slot="icon-only" icon={pencilOutline} color="light"></IonIcon>
                          </IonItemOption>
                          <IonItemOption color="danger" onClick={() => { confirmDeleteRecipient(beneficiary) }}>
                            <IonIcon slot="icon-only" icon={trash} color="light"></IonIcon>
                          </IonItemOption>
                        </IonItemOptions>
                      </IonItemSliding>
                    )
                  }
                  return null;
                })
              }

           

          </IonCardContent>
        </IonCard>


        <IonModal
          ref={verificationScreenModal}
          isOpen={showVerificationScreen}
        >

          <IonContent>

            <IonHeader className="ion-no-border" >
              <IonToolbar >
                <IonButtons slot="start">
                  <IonButton onClick={() => { setShowVerificationScreen(false) }}>
                    <IonIcon slot="icon-only" icon={closeOutline} color="danger" />
                  </IonButton>
                </IonButtons>
              </IonToolbar>

            </IonHeader>

            <SumsubWebSdk
              accessToken={kycToken}
              expirationHandler={getKYCToken}
              config={verificationConfig}
              onMessage={''}
              onError={''}
            />
          </IonContent>

        </IonModal>

      </IonContent>


    </IonPage>
  );
};

const RecipientPage: React.FC = () => (
  <Provider store={store}>
    <Page />
  </Provider>
);

export default RecipientPage;
